import type { UserSex } from "@arbeidsark/shared"
import { useTranslate } from "~/ur-react-hooks"
import { Select, type SelectOption, type SelectProps } from "./Select"

export interface SelectSexProps
  extends Omit<SelectProps<UserSex | null, any>, "options"> {
  value: UserSex | null
  onChange: (value: UserSex | null) => void
}

const SelectSex: React.FC<SelectSexProps> = ({ ...props }) => {
  const translations = useTranslate({
    male: "select-sex.label.male",
    female: "select-sex.label.female",
    ratherNotSay: "select-sex.label.rather-not-say",
  })

  const options: SelectOption<UserSex>[] = [
    { value: "MALE", label: translations.male },
    { value: "FEMALE", label: translations.female },
    { value: "RATHER_NOT_SAY", label: translations.ratherNotSay },
  ]

  return <Select {...props} options={options} />
}

export default SelectSex
